import { render, staticRenderFns } from "./modify-password.vue?vue&type=template&id=6abb938b&scoped=true&"
import script from "./modify-password.vue?vue&type=script&lang=js&"
export * from "./modify-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb938b",
  null
  
)

export default component.exports